<template>
    <div class="login-panel">
        <custom-panel :height="height" :hideTitle="true">
            <template #content>
                <div class="title">用户登录</div>
                <div class="tabs">
                    <a-tabs v-model="activeLoginType" @change="tabChange">
                        <a-tab-pane key="pwdForm" tab="密码登录">
                            <pwd-form ref="pwdForm" />
                        </a-tab-pane>
                        <a-tab-pane key="phoneForm" tab="验证码登录">
                            <phone-form ref="phoneForm" />
                        </a-tab-pane>
                    </a-tabs>
                </div>
                <div class="login-btn">
                    <button class="primary" @click="loginClickHandle">登录</button>
                    <button class="default" @click="registerClickHandle">注册</button>
                </div>
            </template>
        </custom-panel>
    </div>
</template>

<script>
import RsaEncryptUtils from '@/common/rsaEncryptUtils';
import { postLogin } from '@/common/api';
import service from '../../../utils/service';
import CustomPanel from '@/components/custom-panel.vue';
import PhoneForm from '../../login/components/phone-form.vue';
import PwdForm from '../../login/components/pwd-form.vue';

export default {
    props: {
        height: {
            type: Number
        }
    },

    components: {
        CustomPanel,
        PhoneForm,
        PwdForm
    },

    data() {
        return {
            activeLoginType: 'pwdForm'
        };
    },

    methods: {
        tabChange(key) {
            this.activeLoginType = key;
        },

        async loginClickHandle() {
            //验证码登录目前未实现，先return
            if (this.activeLoginType === 'phoneForm') {
                this.$message.warning('暂不支持验证码登录');
                return;
            }
            const formRefs = this.$refs[this.activeLoginType];
            const pass = await formRefs.validate();
            if (!pass) return;
            const form = formRefs.form;

            //登录之前首先获取公钥
            RsaEncryptUtils.getPublicKey().then(() => {
                const publicKey = sessionStorage.getItem('rsa-public-key');
                const params = {
                    id: form.username,
                    password: RsaEncryptUtils.encode(publicKey, form.password)
                };
                postLogin('/kcauth/login', params, publicKey)
                    .then(res => {
                        if (res.status === 200) {
                            this.$message.success('恭喜你，登录成功');
                            service.get('/core/module/sys/logins/account').then(res => {
                                if (res.status === 200) {
                                    const userInfo = JSON.stringify(res.data);
                                    sessionStorage.setItem('userInfo', userInfo);
                                    this.$store.commit('setUserInfo', res.data);
                                    const params = {
                                        phone: res.data.mobile
                                    };
                                    service
                                        .post('/secure/css/module/users/select/login/userinfo', params)
                                        .then(result => {
                                            if (result.status === 200) {
                                                const detailInfo = JSON.stringify(result.data);
                                                sessionStorage.setItem('detailInfo', detailInfo);
                                            }
                                        });
                                }
                            });
                        } else {
                            this.$message.error('登录失败');
                        }
                    })
                    .catch(() => {
                        this.$message.error('用户名或者密码不正确');
                    });
            });
        },

        registerClickHandle() {
            window.open('https://www.ctqtc.com.cn/auth/register.html?client_id=', '_blank');
        }
    }
};
</script>

<style lang="scss" scoped>
$primal-color: #005299;

.login-panel {
    ::v-deep {
        .custom-panel-content {
            display: flex;
            flex-flow: column;
        }
    }

    .title {
        margin: 8px 0 0;
        font-size: 20px;
        font-weight: bold;
        color: $primal-color;
        text-align: center;
        position: relative;

        &::before {
            content: '';
            position: absolute;
            top: 50%;
            left: 25%;
            width: 1em;
            height: 2px;
            background-color: $primal-color;
            transform: translateY(-50%);
        }

        &::after {
            content: '';
            position: absolute;
            top: 50%;
            right: 25%;
            width: 1em;
            height: 2px;
            background-color: $primal-color;
            transform: translateY(-50%);
        }
    }

    .tabs {
        text-align: center;

        ::v-deep {
            .ant-tabs-bar {
                border-bottom: 0 none;
            }

            .ant-tabs-nav .ant-tabs-tab {
                padding: 4px 16px;
            }

            .ant-tabs-nav .ant-tabs-tab:not(:last-child) {
                margin-right: 16px;
            }

            .ant-tabs-tab-active {
                color: #005096;
                font-weight: 600;
            }

            .ant-tabs-ink-bar {
                background-color: #005096;
            }
        }

        ::v-deep {
            .ant-form {
                color: #999;

                .ant-form-item:last-child {
                    margin-bottom: 16px;
                }

                .ant-input-prefix {
                    font-size: 24px;
                    left: 16px;
                }

                .ant-input-affix-wrapper input {
                    height: 40px;
                    font-size: 14px;
                    border: 0 none;
                    background: #fff;
                    border-radius: 4px;
                    padding-left: 48px;
                    border: 1px solid #d3d3d3;
                    &:focus {
                        box-shadow: none;
                    }
                }
            }
        }
    }

    .login-btn {
        margin-top: auto;
        display: flex;
        flex-flow: row wrap;
        gap: 16px;

        > button {
            width: 100%;
            height: 40px;
            border-radius: 4px;
            font-size: 18px;
            font-weight: 600;
            outline: none;
            border: none;
            cursor: pointer;

            &.primary {
                background: linear-gradient(180deg, #006bc7 0%, #005299 100%);
                color: #ffffff;
            }

            &.default {
                color: $primal-color;
                background: #fff;
                border: 1px solid $primal-color;
            }
        }
    }
}
</style>
